import r from "../../../assets/icons/abkhazia.svg.es.js";
import o from "../../../assets/icons/add-join.svg.es.js";
import m from "../../../assets/icons/alert.svg.es.js";
import t from "../../../assets/icons/armenia.svg.es.js";
import i from "../../../assets/icons/arrow-border.svg.es.js";
import p from "../../../assets/icons/arrow-corner.svg.es.js";
import g from "../../../assets/icons/arrow-filled.svg.es.js";
import f from "../../../assets/icons/arrows-expand.svg.es.js";
import v from "../../../assets/icons/award.svg.es.js";
import S from "../../../assets/icons/belarus.svg.es.js";
import n from "../../../assets/icons/book-closed.svg.es.js";
import e from "../../../assets/icons/calendar.svg.es.js";
import a from "../../../assets/icons/call.svg.es.js";
import c from "../../../assets/icons/chevron-left.svg.es.js";
import u from "../../../assets/icons/chevron-right.svg.es.js";
import y from "../../../assets/icons/cinema.svg.es.js";
import l from "../../../assets/icons/circle-close.svg.es.js";
import s from "../../../assets/icons/clock-forward.svg.es.js";
import d from "../../../assets/icons/close.svg.es.js";
import k from "../../../assets/icons/countries/ab.svg.es.js";
import h from "../../../assets/icons/countries/ae.svg.es.js";
import z from "../../../assets/icons/countries/am.svg.es.js";
import b from "../../../assets/icons/countries/az.svg.es.js";
import w from "../../../assets/icons/countries/bd.svg.es.js";
import A from "../../../assets/icons/countries/bh.svg.es.js";
import C from "../../../assets/icons/countries/br.svg.es.js";
import M from "../../../assets/icons/countries/by.svg.es.js";
import T from "../../../assets/icons/countries/cn.svg.es.js";
import x from "../../../assets/icons/countries/cu.svg.es.js";
import B from "../../../assets/icons/countries/dz.svg.es.js";
import F from "../../../assets/icons/countries/eg.svg.es.js";
import E from "../../../assets/icons/countries/et.svg.es.js";
import L from "../../../assets/icons/countries/id.svg.es.js";
import j from "../../../assets/icons/countries/in.svg.es.js";
import K from "../../../assets/icons/countries/ir.svg.es.js";
import P from "../../../assets/icons/countries/kg.svg.es.js";
import D from "../../../assets/icons/countries/kp.svg.es.js";
import I from "../../../assets/icons/countries/kz.svg.es.js";
import R from "../../../assets/icons/countries/ma.svg.es.js";
import V from "../../../assets/icons/countries/mn.svg.es.js";
import q from "../../../assets/icons/countries/my.svg.es.js";
import G from "../../../assets/icons/countries/om.svg.es.js";
import O from "../../../assets/icons/countries/os.svg.es.js";
import Q from "../../../assets/icons/countries/pk.svg.es.js";
import H from "../../../assets/icons/countries/qa.svg.es.js";
import J from "../../../assets/icons/countries/rs.svg.es.js";
import U from "../../../assets/icons/countries/ru.svg.es.js";
import Z from "../../../assets/icons/countries/sa.svg.es.js";
import _ from "../../../assets/icons/countries/sy.svg.es.js";
import N from "../../../assets/icons/countries/th.svg.es.js";
import W from "../../../assets/icons/countries/tj.svg.es.js";
import X from "../../../assets/icons/countries/tm.svg.es.js";
import Y from "../../../assets/icons/countries/tn.svg.es.js";
import $ from "../../../assets/icons/countries/tr.svg.es.js";
import rr from "../../../assets/icons/countries/uz.svg.es.js";
import or from "../../../assets/icons/countries/ve.svg.es.js";
import mr from "../../../assets/icons/countries/vn.svg.es.js";
import tr from "../../../assets/icons/countries/za.svg.es.js";
import ir from "../../../assets/icons/develop-fill.svg.es.js";
import pr from "../../../assets/icons/develop-stroke.svg.es.js";
import gr from "../../../assets/icons/done.svg.es.js";
import fr from "../../../assets/icons/egypt.svg.es.js";
import vr from "../../../assets/icons/exit.svg.es.js";
import Sr from "../../../assets/icons/feather.svg.es.js";
import nr from "../../../assets/icons/file-empty.svg.es.js";
import er from "../../../assets/icons/file-full.svg.es.js";
import ar from "../../../assets/icons/georgia.svg.es.js";
import cr from "../../../assets/icons/grid.svg.es.js";
import ur from "../../../assets/icons/home.svg.es.js";
import yr from "../../../assets/icons/kazakhstan.svg.es.js";
import lr from "../../../assets/icons/kyrgyzstan.svg.es.js";
import sr from "../../../assets/icons/lector.svg.es.js";
import dr from "../../../assets/icons/lecture.svg.es.js";
import kr from "../../../assets/icons/loader.svg.es.js";
import hr from "../../../assets/icons/location.svg.es.js";
import zr from "../../../assets/icons/logo.svg.es.js";
import br from "../../../assets/icons/max.svg.es.js";
import wr from "../../../assets/icons/member.svg.es.js";
import Ar from "../../../assets/icons/menu.svg.es.js";
import Cr from "../../../assets/icons/minus.svg.es.js";
import Mr from "../../../assets/icons/partner.svg.es.js";
import Tr from "../../../assets/icons/play.svg.es.js";
import xr from "../../../assets/icons/plus.svg.es.js";
import Br from "../../../assets/icons/profile.svg.es.js";
import Fr from "../../../assets/icons/quiz.svg.es.js";
import Er from "../../../assets/icons/russia.svg.es.js";
import Lr from "../../../assets/icons/search.svg.es.js";
import jr from "../../../assets/icons/star.svg.es.js";
import Kr from "../../../assets/icons/tajikistan.svg.es.js";
import Pr from "../../../assets/icons/telegram.svg.es.js";
import Dr from "../../../assets/icons/time.svg.es.js";
import Ir from "../../../assets/icons/turkmenistan.svg.es.js";
import Rr from "../../../assets/icons/vk.svg.es.js";
var Vr = {
  "country-ab": k,
  "country-az": b,
  "country-am": z,
  "country-by": M,
  "country-kg": P,
  "country-kz": I,
  "country-tj": W,
  "country-uz": rr,
  "country-dz": B,
  "country-bd": w,
  "country-bh": A,
  "country-br": C,
  "country-ve": or,
  "country-vn": mr,
  "country-eg": F,
  "country-in": j,
  "country-id": L,
  "country-ir": K,
  "country-qa": H,
  "country-cn": T,
  "country-cu": x,
  "country-my": q,
  "country-ma": R,
  "country-mn": V,
  "country-ae": h,
  "country-om": G,
  "country-sa": Z,
  "country-kp": D,
  "country-rs": J,
  "country-sy": _,
  "country-th": N,
  "country-tn": Y,
  "country-tr": $,
  "country-et": E,
  "country-za": tr,
  "country-os": O,
  "country-tm": X,
  "country-pk": Q,
  "country-ru": U,
  "country-russia": Er,
  "country-belarus": S,
  "country-kazakhstan": yr,
  "country-abkhazia": r,
  "country-armenia": t,
  "country-egypt": fr,
  "country-kyrgyzstan": lr,
  "country-georgia": ar,
  "country-tajikistan": Kr,
  "country-turkmenistan": Ir,
  profile: Br,
  logo: zr,
  menu: Ar,
  grid: cr,
  calendar: e,
  "add-join": o,
  feather: Sr,
  star: jr,
  close: d,
  "circle-close": l,
  "chevron-right": u,
  "arrow-left": c,
  "arrow-corner": p,
  "arrows-expand": f,
  "book-closed": n,
  lecture: dr,
  film: y,
  quiz: Fr,
  vk: Rr,
  tg: Pr,
  max: br,
  lector: sr,
  member: wr,
  partner: Mr,
  alert: m,
  exit: vr,
  search: Lr,
  award: v,
  home: ur,
  "file-empty": nr,
  "file-full": er,
  location: hr,
  play: Tr,
  "develop-stroke": pr,
  "develop-fill": ir,
  "arrow-border": i,
  "arrow-filled": g,
  "clock-forward": s,
  minus: Cr,
  plus: xr,
  time: Dr,
  done: gr,
  call: a,
  loader: kr
}, Mm = Vr;
export {
  Vr as _untypedIconsMap,
  Mm as iconsMap
};
